import Cookies from 'js-cookie'
import Tribute from 'tributejs'
import { makeMeSticky } from '@app/utils/domHelpers'

// Those variables are exposed to global scope, they are available in vendor folder
// It allows to use packages installed through npm in assets pipeline files
// They should be removed after getting rid of bower

window.Cookies = Cookies
window.Tribute = Tribute
window.makeMeSticky = makeMeSticky
